import {inject, Injectable} from '@angular/core';
import {CorporateFormsService} from '../corporate/services/corporate-forms.service';
import {FormTypeEnum} from '../corporate/enums/form-type.enum';
import {Observable} from 'rxjs';
import {of} from 'rxjs/internal/observable/of';
import {IFormService} from '../corporate/models/IFormService.interface';

@Injectable({
  providedIn: 'root'
})
export class PlutonInvoicingClientService {

  private readonly corporateService = inject(CorporateFormsService);

  get invoicingClient(): {
    clientId: number;
    formType: number,
    individual_businessId: number,
    client_name: string,
    client_code: string,
    appartment:string,
    buildingName:string,
    buildingNum:string,
    floor:string,
    city:string,
    country:string,
    houseNum:string,
    postcode:string,
    state:string,
    street:string,
    zip:string,
    plutosCustomerId?: string
  } {
    return JSON.parse(localStorage.getItem('invoicingClient'));
  }

  getClientServices() {
    return this.defineClientType<IFormService[]>(
      this.invoicingClient.formType,
      this.corporateService.getIndividualServices(this.invoicingClient.individual_businessId),
      this.corporateService.getBusinessServices(this.invoicingClient.individual_businessId),
    );
  }

  private defineClientType<T>(formType: FormTypeEnum, individualRequest: Observable<T>, businessRequest: Observable<T>): Observable<T> {
    switch (formType) {
      case FormTypeEnum.Individual:
        return individualRequest;
      case FormTypeEnum.Business:
        return businessRequest;
      default:
        return of(null);
    }
  }

}
